import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import BreadcrumbBar from "./components/BreadcrumbBar";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useLangPath } from "./hooks/useLangPath";
import Seo from "./Seo";

function Metals() {
  const { t } = useTranslation();
  const langPath = useLangPath();

  const metals = [
    { label: "Gold", path: "/metals/gold-ai-trading-predictions" },
    { label: "Silver", path: "/metals/silver-ai-trading-predictions" },
    { label: "Copper", path: "/metals/copper-ai-trading-predictions" },
  ];

  return (
    <>
      <Seo
        title={t("metals.pageTitle")}
        description={t("metals.pageDesc")}
        canonical="/metals"
        breadcrumbs={[
          { name: t("common.home"), path: "/" },
          { name: t("nav.metals"), path: "/metals" },
        ]}
      />
      <BreadcrumbBar crumbs={[{ label: t("common.home"), to: langPath("/") }, { label: t("nav.metals") }]} />
      <Container style={{ paddingTop: 24, paddingBottom: 60 }}>
      <h1>{t("metals.h1")}</h1>
      <p style={{ color: "#6c757d", marginBottom: 32 }}>{t("metals.pageDesc")}</p>
      <Row>
        {metals.map(({ label, path }) => (
          <Col md={4} key={path}>
            <Link to={langPath(path)} className="text-decoration-none">
              <Card className="mb-4"><Card.Body><Card.Title>{label}</Card.Title></Card.Body></Card>
            </Link>
          </Col>
        ))}
      </Row>
      </Container>
    </>
  );
}

export default Metals;
